import "./Footer.css";
import { Link } from "react-router-dom";

import logo from "../../assets/images/Logo Full Blue 1.png";
import emailIcon from "../../assets/images/Email@2x.png";
import phoneIcon from "../../assets/images/Phone@2x.png";
import playStore from "../../assets/images/Group.svg";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-top">

        <div className="footer-container">

          {/* Company Info */}

          <div className="footer-column footer-company">

            <Link to="/">
              <img
                src={logo}
                alt="Finsall company logo"
                className="footer-logo"
              />
            </Link>

            <div className="footer-contact">

              <div className="footer-contact-item">
                <img
                  src={emailIcon}
                  alt="Email support icon"
                />

                <a href="mailto:info@finsall.com">
                  info@finsall.com
                </a>
              </div>

              <div className="footer-contact-item">
                <img
                  src={phoneIcon}
                  alt="Phone support icon"
                />

                <span>
                  18005705797
                </span>
              </div>

            </div>

            <div className="footer-social">

              <a
                href="https://www.linkedin.com/company/finsall/"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>

              <a
                href="https://twitter.com/Finsall_"
                target="_blank"
                rel="noreferrer"
              >
                Twitter
              </a>

            </div>

          </div>

          {/* Navigation */}

          <div className="footer-column">

            <h4>Navigation</h4>

            <ul>

              <li>
                <Link to="/">
                  Home
                </Link>
              </li>

              <li>
                <Link to="/about-us">
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/faq">
                  FAQs
                </Link>
              </li>

              <li>
                <Link to="/contact-us">
                  Contact Us
                </Link>
              </li>

            </ul>

          </div>

          {/* Intermediaries */}

          <div className="footer-column">

            <h4>
              For Intermediaries
            </h4>

            <ul>

              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.finsall"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Our App
                </a>
              </li>

              <li>
                <Link to="/how-it-works">
                  Process Workflow
                </Link>
              </li>

              <li>
                <Link to="/intermediaries">
                  Benefits
                </Link>
              </li>

              <li>
                <Link to="/contact-us">
                  Training Session
                </Link>
              </li>

            </ul>

          </div>

          {/* Download App */}

          <div className="footer-column">

            <h4>
              Download Intermediary App
            </h4>

            <a
              href="https://play.google.com/store/apps/details?id=com.finsall"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={playStore}
                alt="google play download button for intermediary app"
                className="playstore-image"
              />
            </a>

          </div>

        </div>

      </div>

      {/* Footer Bottom */}

      <div className="footer-bottom">

        <div className="footer-container footer-bottom-content">

          <p>
            © All Rights Reserved
          </p>

          <div className="footer-links">

            <Link to="/terms">
              Terms & Conditions
            </Link>

            <Link to="/privacy-policy">
              Privacy Policy
            </Link>

            <Link to="/compliance">
              Compliance
            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;